import { createContext, ReactNode, useRef } from "react";

import { createCaseBlockScrollStore } from "src/cases/caseView/CaseBlockScrollStore";

export type CaseBlockScrollContextType = ReturnType<
  typeof createCaseBlockScrollStore
>;

export const CaseBlockScrollContext =
  createContext<CaseBlockScrollContextType | null>(null);

type CaseBlockScrollProviderProps = {
  children: ReactNode;
};

export const CaseBlockScrollProvider = ({
  children,
}: CaseBlockScrollProviderProps) => {
  const storeRef = useRef<CaseBlockScrollContextType>();

  if (!storeRef.current) {
    storeRef.current = createCaseBlockScrollStore();
  }

  return (
    <CaseBlockScrollContext.Provider value={storeRef.current}>
      {children}
    </CaseBlockScrollContext.Provider>
  );
};

// Re-export hooks from the hooks file
export {
  useActiveBlock,
  useCaseBlockScrollTarget,
  useCaseBlockScrollTo,
  useLastFocusedBlock,
  useUnsetLastFocusedBlock,
} from "src/cases/caseView/CaseBlockScrollHooks";
